/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {
  forwardRef,
  memo,
  useImperativeHandle
} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {BulkActionEntity, GenericObject} from '@ion/core/src/types/entities';
import {useEditorStyles} from '../../hooks/useEditorStyles';
import {BodyTypography} from '../../typography/BodyTypography';
import EmbeddedForm from './EmbeddedForm';

interface unPairFormProps {
  entity: BulkActionEntity;
  onSave: (details: GenericObject) => void;
}

/**
 * Re-usable form with the details for unpair entity.
*/
export const UnpairForm = forwardRef(({
  entity,
  onSave
}: unPairFormProps, ref) => {
  const {classes} = useEditorStyles();

  const onSubmit = () => {
    onSave({});
  };

  useImperativeHandle(ref, () => ({
    onSubmit
  }), [onSubmit]);

  return (
    <EmbeddedForm>
      <div className={classes.centered}>
        <BodyTypography variant={'body2'} align={'center'}>
          {translate(`common:editors.bulkActions.unpair.${entity}`)}
        </BodyTypography>
      </div>
    </EmbeddedForm>
  );
});

export default memo(UnpairForm);
